import { definePreset } from '@primevue/themes';
import Lara from '@primevue/themes/lara';

export default definePreset(Lara, {
  semantic: {
    primary: {
      50: '#9FAFFF',
      100: '#8A9EFF',
      200: '#617CFF',
      300: '#395AFF',
      400: '#1038FF',
      500: '#0027E6',
      600: '#001DAE',
      700: '#001476',
      800: '#000A3E',
      900: '#000106',
      950: '#000000',
    },
    colorScheme: {
      focusRing: {
        shadow: 'none',
      },
      formField: {
        hoverBorderColor: '{surface.400}',
      },
    },
  },
  components: {
    button: {
      root: {
        label: {
          fontWeight: 'normal',
        },
      },
      colorScheme: {
        outlined: {
          secondary: {
            borderColor: '{surface.300}',
            color: '{surface.700}',
          },
        },
      },
    },
  },
});
